export const APP_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';
export const REACT_APP_STRIPE_RETURN_URL = process.env.REACT_APP_STRIPE_RETURN_URL || 'http://localhost:3000';
export const REACT_APP_SCANDIT_KEY = process.env.REACT_APP_SCANDIT_KEY;
export const REACT_APP_SCANDIT_ENGINE_LOCATION = process.env.REACT_APP_SCANDIT_ENGINE_LOCATION;
export const REACT_APP_STRIPE_PUBLISH_KEY = process.env.REACT_APP_STRIPE_PUBLISH_KEY;
